import { Dot } from "components/Dot";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { getFormElementType } from "utilities/freefieldUtils";

interface Props {
  environment: server.dto.Environments
  permissions: server.dto.FreeFieldDefinitionPermission[]
  categories: server.dto.FreeFieldCategorySmall[];
}

export const SidePanelFreeFieldPermissionsSection = (props: Props) => {
  return <>
    {props.categories.map((category) => <div key={category.freeFieldCategoryId} className="flex-column gap">
      <h4>{category.title}</h4>
      {category.definitions.map((definition) => <div className="flex justify-space-between" key={definition.freeFieldDefinitionId}>
        <SmallDetails
          label={definition.title}
          subLabel={getFormElementType(definition.type).text}
        />
        <FreeFieldPermission
          environment={props.environment}
          permissions={props.permissions}
          definition={definition}
        />
      </div>)}
    </div>)}
  </>
}

interface FreeFieldPermissionProps {
  environment: server.dto.Environments
  permissions: server.dto.FreeFieldDefinitionPermission[]
  definition: server.dto.FreeFieldDefinitionSmall
}

const FreeFieldPermission = (props: FreeFieldPermissionProps) => {
  const permissions = props.permissions.filter((p) => p.freeFieldDefinitionId === props.definition.freeFieldDefinitionId);

  if (permissions === null) {
    return <Hidden />;
  }

  if (permissions[0].level === "view") {
    return <View />;
  }

  if (permissions[0].level === "viewModify") {
    return <ViewModify environment={props.environment} />;
  }

  return <Hidden />;
}

const Hidden = () => <div><Dot color="red" /> {RESX.GeneralLabels.NotVisible}</div>;

const View = () => <div><Dot color="yellow" /> {RESX.GeneralLabels.Visible}</div>;

const ViewModify = ({ environment }: { environment: server.dto.Environments }) => <div><Dot color="green" /> {environment === "internal" ? RESX.SoUser.Modify : RESX.SoUser.Access}</div>;
